// src/pages/TableCitoyens.jsx
import React from "react";
import Layout from "../components/Layout";
import ListeDesReunion from "../components/Manager/ListeDesReunion";

function Reunions() {
  
  return (
    <Layout >
      <div className="p-6">
        <ListeDesReunion />
      </div>
    </Layout>
  );
}

export default Reunions;
